@import "~/styles/v1/_variables.scss";
@import "~/styles/v1/_spacing.scss";

.FlyoverAccordion {
  border-bottom: $border-standard;
  margin-bottom: $size-XS;

  &:last-child:not(:first-of-type) {
    border-bottom: 0;
  }

  .Icon {
    vertical-align: top;
  }
}
